import React from 'react';
import bgFooter from '../assets/footer-bg.jpg';
import { TbMovie } from 'react-icons/tb';
import { Link } from 'react-router-dom';

const Footer = ({ headerMovies, title }) => {
  console.log(title);
  return (
    <>
      {headerMovies ? (
        <div
          className="w-full pt-28 pb-4 px-0 relative bg-top bg-cover bg-no-repeat  after:absolute after:bottom-0 after:left-0 after:w-full after:h-24 after:bg-gradient-to-t after:from-black after:to-black/5"
          style={{
            backgroundImage: `url(${bgFooter})`,
          }}
        >
          <h1 className="z-10 relative text-white font-bold text-center text-2xl">
            {title}
          </h1>
        </div>
      ) : (
        <div
          className="w-full py-28 px-0 relative bg-center bg-cover bg-no-repeat flex flex-col justify-center items-center gap-4"
          style={{ backgroundImage: `url(${bgFooter})` }}
        >
          <Link to="/" className="flex flex-row items-center gap-2">
            <TbMovie className="text-yellow-500 w-12 h-auto" />
            <h2 className="text-white font-semibold text-2xl md:text-4xl">
              iMovie
            </h2>
          </Link>
          <a
            href="https://www.themoviedb.org/documentation/api"
            target="_blank"
            className="font-semibold"
          >
            API Documentation
          </a>
        </div>
      )}
    </>
  );
};

export default Footer;
